import React from 'react';
import { connect } from 'react-redux';

import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import useCollectionState from '@src/components/common/collectionParams/useCollectionState';
import CollectionBusinessStore from '@src/service/business/common/collectionBusinessStore';
import { ICollectionData, ICollectionFetchPayload } from '@src/service/business/common/types';
import CourseListBusinessStore, { ICourseListFilter } from '@src/service/business/courses/courseListBusinessStore';
import { ICourse } from '@src/model/course/Course';
import { ICourseGroup } from '@src/model/course/CourseGroup';
import CourseHelperUtils from '@src/components/course/common/CourseHelperUtils';
import PrivateCourseListView from '@src/components/course/list/catalog/PrivateCourseListView';

// -- Const
// ----------
const VIEW_NAME = '@@ADMIN_COURSE_LIST';
// -- Prop types
// ----------

export interface IAdminCourseListContainerOwnProps {
  viewName?: string;
  predefinedListFilter?: ICourseListFilter;
  showCourseListActions?: boolean;
}
export interface IAdminCourseListContainerStateProps {
  courseGroups: ICourseGroup[];
  courseList: ICollectionData<ICourse>;
}
export interface IAdminCourseListContainerDispatchProps {
  fetchCourseList: (params: ICollectionFetchPayload<ICourseListFilter>) => any;
  clearCourseList: () => void;
}
type IAdminCourseListContainerProps = IAdminCourseListContainerOwnProps & IAdminCourseListContainerStateProps & IAdminCourseListContainerDispatchProps & IWithLocalizeOwnProps;

// -- Component
// ----------

/** Describe your component ... */
const AdminCourseListContainer = (props: IAdminCourseListContainerProps) => {
  const [collectionParams, updateCollectionParams] = useCollectionState<ICourseListFilter>({
    viewName: props.viewName ?? VIEW_NAME,
    updateFn: props.fetchCourseList,
    initialValues: { filter: props.predefinedListFilter },
  });

  return (
    <PrivateCourseListView
      isCourseStatusFilterEnabled={true}
      showCourseListActions={props.showCourseListActions}
      courseList={props.courseList}
      courseGroups={props.courseGroups}
      courseListFilter={collectionParams.filter}
      sortValue={collectionParams.sort}
      getPath={CourseHelperUtils.getAdminPath}
      onSortChange={updateCollectionParams.onSortChange}
      onFilterChange={updateCollectionParams.onFilterSet}
      onPageChange={updateCollectionParams.onPageChange}
    />
  );
};

// -- HOCs and exports
// ----------

// `state` parameter needs a type annotation to type-check the correct shape of a state object but also it'll be used by "type inference" to infer the type of returned props
const mapStateToProps = (state: any, ownProps: IAdminCourseListContainerOwnProps): IAdminCourseListContainerStateProps => ({
  courseGroups: CollectionBusinessStore.selectors.getCollectionContent(state, 'CourseGroup'),
  courseList: CourseListBusinessStore.selectors.getCourseList(state),
});

// `dispatch` parameter needs a type annotation to type-check the correct shape of an action object when using dispatch function
const mapDispatchToProps = (dispatch: any): IAdminCourseListContainerDispatchProps => ({
  fetchCourseList: (params: ICollectionFetchPayload<ICourseListFilter>) => dispatch(CourseListBusinessStore.actions.fetchCourseList(params)),
  clearCourseList: () => dispatch(CourseListBusinessStore.actions.clearCourseList()),
});

export default connect<IAdminCourseListContainerStateProps, IAdminCourseListContainerDispatchProps, IAdminCourseListContainerOwnProps>(mapStateToProps, mapDispatchToProps)(withLocalize(AdminCourseListContainer as any));
